import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EMPTY, catchError } from 'rxjs';
import { AuthRateLimitService } from '@core/services/auth-rate-limit.service';

export const RATE_LIMIT_KEYS = {
  LOGIN: 'auth/login',
  REGISTER: 'auth/register',
  FORGOT_PASSWORD: 'auth/password-reset',
  REFRESH_TOKEN: 'token/refreshToken',
} as const;

const URL_TO_KEY: ReadonlyArray<{ pattern: string; key: string }> = [
  { pattern: '/auth/login', key: RATE_LIMIT_KEYS.LOGIN },
  { pattern: '/auth/register', key: RATE_LIMIT_KEYS.REGISTER },
  { pattern: '/auth/password-reset', key: RATE_LIMIT_KEYS.FORGOT_PASSWORD },
  { pattern: '/token/refreshToken', key: RATE_LIMIT_KEYS.REFRESH_TOKEN },
];

function resolveRouteKey(url: string): string | null {
  return URL_TO_KEY.find(({ pattern }) => url.includes(pattern))?.key ?? null;
}

export const rateLimitInterceptor: HttpInterceptorFn = (req, next) => {
  const authRateLimitService = inject(AuthRateLimitService);

  return next(req).pipe(
    catchError((error) => {
      if ((error?.status ?? 0) !== 429) {
        throw error;
      }

      const routeKey = resolveRouteKey(req.url);
      if (!routeKey) {
        throw error;
      }

      const fromHeader = error?.headers?.get?.('Retry-After');
      const fromBody = error?.error?.retryAfter;
      const parsed = Number(fromHeader ?? fromBody ?? 60);
      const seconds = Number.isFinite(parsed) && parsed > 0 ? parsed : 60;

      authRateLimitService.setLockout(routeKey, seconds);

      return EMPTY;
    }),
  );
};
